import React from 'react'
import { AsyncPaginate } from 'react-select-async-paginate'
import { useState } from 'react';
import { GEO_API_URL, geoApiOptions } from '../../api';

export default function Search({ onSearchChange }) { //1
  const [search, setSearch] = useState(null); //What happen on Searching, initially value is set to null or nothing
  //Now below handleOnChange mean when user search something so, I have to serve him the data that come from
  //API 

  const loadOptions = (inputValue) => { //4
    //Below function fetch API url, cities with min population of 1M and how it fetch by the name that is input by the user    
    return fetch(`${GEO_API_URL}/cities?minPopulation=50000&namePrefix=${inputValue}`, geoApiOptions)
      //geoApiOptions is actually header that "GET" method to demand the key and the url
      .then((response) => response.json())
      .then((response) => {
        return {
          options: response.data.map((city) => { //Whatever data we are getting should map over the variable or object
            //name city and from that return the specified label and value as given below
            return {
              value: `${city.latitude} ${city.longitude}`,
              label: `${city.name} ${city.countryCode}`
            };
          }),
        };
      })
      .catch((err) => console.error(err));
  }

  const handleOnChange = (searchData) => {  //2
    setSearch(searchData); //Set search to the data coming from the API
    onSearchChange(searchData);
  }
  // We actually have two sub pages or parts of Search => first Current Weather and secondly Future Forecast


  return (
    <div>
      {/*AsyncPaginate has build input types that creates the search bar whose width and margin is set by container-1*/}
      <AsyncPaginate
        placeholder="Search for City"
        debounceTimeout={600}
        value={search}
        onChange={handleOnChange}
        loadOptions={loadOptions}

      />



    </div>
  )
}
